import { GatsbyImage, type IGatsbyImageData } from 'gatsby-plugin-image'

import Image from '@/components/Image'
import { useState } from 'react'

export type ProcessedImage = {
  childImageSharp: {
    gatsbyImageData: IGatsbyImageData
  }
}

type Props = {
  image?: ProcessedImage
  alt?: string
  className?: string
  fallback?: string
  fallbackUrl?: string
  strategy?: 'lazy' | 'eager'
  dataTest?: string
}

export const LocalImage = ({
  image,
  alt,
  className,
  fallback,
  fallbackUrl,
  strategy = 'lazy',
  dataTest,
}: Props) => {
  const [fallbackUrlFailed, setFallbackUrlFailed] = useState(false)

  if (image?.childImageSharp?.gatsbyImageData) {
    return (
      <GatsbyImage
        image={image.childImageSharp.gatsbyImageData}
        alt={alt || ''}
        className={className}
        loading={strategy}
        data-test={dataTest}
      />
    )
  }

  if (fallbackUrl && !fallbackUrlFailed) {
    return (
      <img
        src={fallbackUrl}
        alt={alt || ''}
        className={className}
        loading={strategy}
        onError={() => setFallbackUrlFailed(true)}
        data-test={dataTest}
      />
    )
  }

  if (fallback) {
    return (
      <Image
        type={fallback}
        alt={alt || ''}
        className={className}
        loading={strategy}
        data-test={dataTest}
      />
    )
  }

  return null
}
